module.exports = __webpack_public_path__ + "static/media/the tree in the window.ebab56b3.png";